import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IFootballCompetition,
  IFootballHostedCompetition,
} from "../../../commons/models/football/interface/i-football-competition";
import { FootballCompetition } from "../../../commons/models/football/football-competition";
import { FootballHostedCompetition } from "../../../commons/models/football/football-hosted-competition";

interface FetchedCompetitionState {
  fetchedCompetition: IFootballCompetition | IFootballHostedCompetition;
}

const initialState: FetchedCompetitionState = {
  fetchedCompetition: new FootballCompetition() || new FootballHostedCompetition(),
};

export const FetchedCompetitionSlice = createSlice({
  name: "fetchedCompetitionSlice",
  initialState,
  reducers: {
    setFetchedCompetitionData: (state, action: PayloadAction<IFootballCompetition | IFootballHostedCompetition>) => {
      state.fetchedCompetition = action.payload;
    },

    cleanUpFetchedCompetitionData: (state) => {
      state.fetchedCompetition = new FootballCompetition() || new FootballHostedCompetition();
    },
  },
});

export const { setFetchedCompetitionData, cleanUpFetchedCompetitionData } = FetchedCompetitionSlice.actions;
export default FetchedCompetitionSlice.reducer;
